/**
 * This file can be replaced or change values to generate a new platform
 * 1. main domain url
 * 2. career domain url (it's basically as same as the main domain url)
 *    This would be different just in case we host the career pages on a different hosting
 */

import { ConfigTitle } from './interfaces/config-title';

export const configuration = {
  /**
   * The main domain url
   * Just replace this with a new domain without http or https
   */
  domain: 'readyats.com',

  /**
   * If we host career templates on the main hosting, this will be as same as the main domain
   * define this, just in the case we host career pages on a different hosting
   * Please note that you need to set only with the domain name without http or https
   */
  career: 'readyats.com',

  /**
   * represent the sub domain for front end/angular application
   * the site url/domain will be next.*
   */
  site: 'next',

  /**
   * represent the sub domain for backend end/coldfusion application
   * the backend API end point will be api.*
   */
  api: 'api',
};

export const titleConfigs: ConfigTitle[] = [
  // make sure to set the 'en' as it will be the default
  {
    key: 'en',
        value: 'ReadyATS'
    }, 
    {
        key: 'cn',
    value: 'ReadyATS',
  },
  {
    key: 'fr',
    value: 'ReadyATS',
  },
];

export const ScheduleInterval = {
  start: '9:00',
  end: '17:00',

  break: 1, // break in hours between intervals
  durations: 1, // duration in hours for adding intervals
};
